import React from "react";
import {
    Box,
    Typography,
    Button,
    Grid,
    Card,
    CardContent,
    CardActionArea,
    CardMedia,
    Container,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ChatIcon from "@mui/icons-material/Chat";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { CMDHero, city, female_agent, worker, processes } from '../components/Images/images';
import GroupIcon from "@mui/icons-material/Group";




export default function Home({ firstName }) {


    return (
        <Box sx={{paddingTop: "3em" }}>
            {/* Hero Section */}
            <Box
                sx={{
                    position: "relative",
                    minHeight: {xs:260, sm:320, md:420},
                    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.3),   /* ciemny u góry */
        rgba(0, 0, 0, 0.1)    /* jaśniejszy na dole */
      ),
      url(${CMDHero})
    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: 3,
                    borderRadius: "24px",
                }}
            >
                {/*<Box*/}
                {/*    sx={{*/}
                {/*        position: "absolute",*/}
                {/*        inset: 0,*/}
                {/*        backgroundColor: "rgba(43, 21, 12, 0.5)", // 🔹 zmień 0.4 → 0.2 / 0.6 w zależności od efektu*/}
                {/*        zIndex: 1,*/}
                {/*    }}*/}
                {/*/>*/}
                <Box
                    sx={{
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        padding: "2rem",
                        borderRadius: "8px",
                        textAlign: "center",
                        zIndex: 2,
                    }}
                >
                    <Typography variant="h3" gutterBottom sx={{ fontSize: "3.3rem", fontWeight: 500 }}>
                        Welcome back, {firstName}!
                    </Typography>
                    <Typography variant="h5" sx={{ fontSize: "1.2rem", fontWeight: 200 }}>
                        Explore your AI agents and tools to supercharge your workflows.
                    </Typography>
                </Box>
            </Box>

            {/* Cards Section */}
            <Container sx={{ mt: 8, mb: 8, maxWidth: "1100px !important" }}>
                <Grid
                    container
                    spacing={4}
                    justifyContent="center"
                    alignItems="stretch"
                >
                    {/* AI Chat Card */}
                    <Grid item xs={12} sm={6} md={4} display="flex">
                        <Card
                            sx={{
                                width: "100%",
                                borderRadius: "14px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                                transition: "all 0.25s ease",
                                height: 200,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                "&:hover": {
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                    transform: "translateY(-4px)",
                                },
                            }}
                        >
                            <CardActionArea
                                href="/chat"
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                    textAlign: "left",
                                    p: 3,
                                }}
                            >
                                {/* Ikona */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1.2,
                                    }}
                                >
                                    <GroupIcon sx={{ fontSize: 34, color: "rgb(117 117 117);" }} />
                                </Box>

                                {/* Treść */}
                                <CardContent
                                    sx={{
                                        p: 0,
                                        "&:last-child": { pb: 0 },
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 600,
                                            color: "#5e5e5e",
                                            mb: 0.6,
                                            fontSize: "1rem",
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        AI Chat
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.4,
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        Create your own automation effortlessly through an intuitive chat.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>

                    {/* My Agents Card */}
                    <Grid item xs={12} sm={6} md={4} display="flex">
                        <Card
                            sx={{
                                width: "100%",
                                borderRadius: "14px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                                transition: "all 0.25s ease",
                                height: 200,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                "&:hover": {
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                    transform: "translateY(-4px)",
                                },
                            }}
                        >
                            <CardActionArea
                                href="/agents"
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                    textAlign: "left",
                                    p: 3,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1.2,
                                    }}
                                >
                                    <AssignmentIcon sx={{ fontSize: 34, color: "rgb(117 117 117);" }} />
                                </Box>

                                <CardContent
                                    sx={{
                                        p: 0,
                                        "&:last-child": { pb: 0 },
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 600,
                                            color: "#5e5e5e",
                                            mb: 0.6,
                                            fontSize: "1rem",
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        My Agents
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.4,
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        View and manage your AI-driven workflows and processes.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>

                    {/* Sophona Studio Card */}
                    <Grid item xs={12} sm={6} md={4} display="flex">
                        <Card
                            sx={{
                                width: "100%",
                                borderRadius: "14px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                                transition: "all 0.25s ease",
                                height: 200,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                "&:hover": {
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                    transform: "translateY(-4px)",
                                },
                            }}
                        >
                            <CardActionArea
                                href="https://pub-b9f18878fd1a47f38166298dd52e1852.r2.dev/Sophona%20Studio%20Setup%201.0.0.exe"
                                download
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                    textAlign: "left",
                                    p: 3,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1.2,
                                    }}
                                >
                                    <DownloadIcon sx={{ fontSize: 34, color: "rgb(117 117 117);" }} />
                                </Box>

                                <CardContent
                                    sx={{
                                        p: 0,
                                        "&:last-child": { pb: 0 },
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 600,
                                            color: "#5e5e5e",
                                            mb: 0.6,
                                            fontSize: "1rem",
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        Sophona Studio
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.4,
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        Download the latest version of the worker client for your agents.
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            </Container>


        </Box>
    );
}
